module.exports = __webpack_public_path__ + "img/op_lung.fadca51b.svg";